<script>
import { Pie } from "vue-chartjs";

export default {
  extends: Pie,
  mounted() {
    this.renderChart(
      {
        labels: ['Запись в соцсети', 'Новость', 'Микроблог', 'Пост', 'Комментарий'],
        datasets: [
          {
            label: "Запись в соцсети",
            backgroundColor: ["#24eaff", "#ff9800", "#e91e63", "#8BC34A", "#9C27B0"],
            data: [1456, 623, 705, 1217, 2236],
          }
        ]
      },
      { responsive: true, maintainAspectRatio: false, scales: {
              xAxes: [{
                  barThickness: 7,
              }]
          } }
    );
  },
  methods: {
     
      getRandomInt () {
        return Math.floor(Math.random() * (50 - 5 + 1)) + 5
      }
    }
};
</script>
